import { useEffect, useRef } from 'react';
import { registerNativeBackHandler } from './native-back-button.service';

export const useNativeBackButton = (handler: VoidFunction, enabled = true): void => {
  const latestHandler = useRef(handler);

  useEffect(() => {
    latestHandler.current = handler;
  }, [handler]);

  // Registered per `enabled`, not per render: re-registering would reorder it above a later overlay.
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    return registerNativeBackHandler(() => latestHandler.current());
  }, [enabled]);
};
